module.exports = __webpack_public_path__ + "img/a1dd31a.png";